export const validator = ({
  email,
  first_name: firstName,
  last_name: lastName,
  place,
}) => {
  const errors = {};
  if (!email) errors.email = 'email is required';
  else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) errors.email = 'invalid email format';
  // if (!password) errors.password = 'password is required';
  if (!firstName) errors.first_name = 'first name is required'
  if (!lastName) errors.last_name = 'last name is required'
  if (!place) errors.place = 'location is required'

  return errors;
};

export default validator;
